@use '~/theme/theme' as *;
@use '~/theme/typography';
@use '~/theme/breakpoints';

@include breakpoints.mobile-only {
  .modalOverlay.responsive {
    .ariaModal,
    .dialog {
      height: 100%;
      width: 100%;
      min-width: 0;

      // !important declaration is necessary due to maxWdith style override
      max-width: none !important;
      max-height: none;
      border-radius: 0;
    }
  }
}

.forceForeground {
  --z-index-modal: 200000;
}

.dialog {
  @include border-radius(md);
  @include shadow(lg);

  background: white;
  padding: spacing(3) 0;
  display: flex;
  flex-direction: column;
  gap: spacing(3);
  min-width: 400px;
  max-height: 95vh;
  overflow: hidden;
  margin: 0 auto;

  &:focus {
    outline: 0;
  }

  &[data-focus-visible] {
    outline: 2px solid color(violet-600);
    outline-offset: 2px;
  }

  .icon {
    color: color(violet-600);
  }

  &[data-action='destructive'] .icon {
    color: color(lobster-800);
  }

  &[data-action='confirm'] .icon {
    color: color(green-800);
  }
}

.modalOverlay {
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 25%);
  z-index: z-index(modal);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);

  &.hidden {
    visibility: hidden;
  }

  &.fullWidth {
    .ariaModal,
    .dialog {
      width: 100%;
    }
  }
}

.title {
  @include typography.subtitle2;
  @include typography.semibold;

  display: flex;
  align-items: center;
  gap: spacing(1.5);
  padding: spacing(3);
  margin: spacing(-3) 0;
}

.titleChildren {
  display: flex;
  align-items: center;
  gap: spacing(1.5);
  flex: 1;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: spacing(1.5);
  padding: 0 spacing(3);
}

.content {
  padding: 0 spacing(3);
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex-grow: 1;
}

.loadingContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}
